// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1EKfX","infoBtn":"quickbooks_infoBtn__1RzqX","formBox":"quickbooks_formBox__14J1A","formFooter":"quickbooks_formFooter__2jetJ"};